import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

function Impressum() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <button className="legal-back" onClick={() => navigate('/')}>
        ← Zurück
      </button>
      <div className="legal-content">
        <h1>Impressum</h1>
        <p className="legal-updated">Angaben gemäß § 5 TMG</p>

        <h2>Betreiber</h2>
        <p>
          Emin Tavli<br />
          Westendstraße 28<br />
          90427 Nürnberg<br />
          Deutschland
        </p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:tavlin@hotmail.de">tavlin@hotmail.de</a>
        </p>

        <h2>Hinweis</h2>
        <p>
          Diese Website ist ein privates Portfolio ohne gewerbliche Tätigkeit.
          Es besteht keine Umsatzsteuerpflicht und kein Handelsregistereintrag.
        </p>

        <h2>Haftung für Inhalte</h2>
        <p>
          Als Betreiber bin ich für eigene Inhalte nach den allgemeinen Gesetzen verantwortlich.
          Für verlinkte externe Seiten übernehme ich keine Haftung, der jeweilige Anbieter ist
          selbst verantwortlich.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die auf dieser Website erstellten Inhalte und Werke unterliegen dem deutschen Urheberrecht.
          Eine Vervielfältigung oder Verbreitung bedarf der schriftlichen Zustimmung des Betreibers.
        </p>
      </div>
    </div>
  );
}

export default Impressum;
